// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Workbox } from 'workbox-window';
// Si quieres que funcione offline, descomenta la siguiente línea (o ajústala)
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// serviceWorkerRegistration.register();

import App from './App';

// Estilos globales adicionales (opcional, mantén el que ya existe)
// Pero asegúrate de que importe App.css desde App.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


if ('serviceWorker' in navigator) {
  const wb = new Workbox('/service-worker.js');

  wb.addEventListener('waiting', (event) => {
    // Muestra el prompt de actualización
    // Puedes usar un estado global, pero por simplicidad, crearemos un evento personalizado
    const updateEvent = new CustomEvent('swWaiting', { detail: { wb } });
    window.dispatchEvent(updateEvent);
  });

  wb.register();
}